import React from 'react';
import { Card, Collapse, Table, Tag } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { ControlTowerQueryParams } from '@/services/manufacturingControlTower.service';
import { useControlTowerFabrication } from '@/hooks/useManufacturingControlTower';

const FabricationUnitControlBoard: React.FC<{ filters?: ControlTowerQueryParams }> = ({ filters }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useControlTowerFabrication(filters);
  const wos = (data as { work_orders?: Array<Record<string, unknown>> })?.work_orders ?? [];

  return (
    <Card id="fabrication" title="Fabrication unit control board" style={{ marginTop: 16 }} loading={isLoading}>
      <Collapse
        items={wos.map((wo) => ({
          key: String(wo.work_order_id),
          label: `${String(wo.work_order_number)} — ${String(wo.customer_name || '')}`,
          children: (
            <Table
              size="small"
              pagination={false}
              rowKey={(u: Record<string, unknown>) => String(u.production_unit_number)}
              dataSource={(wo.units as Record<string, unknown>[]) || []}
              columns={[
                { title: 'Unit', dataIndex: 'production_unit_number', width: 70 },
                {
                  title: 'Stages',
                  render: (_: unknown, u: Record<string, unknown>) => {
                    const stages = (u.stages as Array<Record<string, unknown>>) || [];
                    return stages.map((s) => (
                      <Tag key={String(s.stage_id)} color={s.is_overdue ? 'red' : 'blue'}>
                        {String(s.operation_label)}: {String(s.stage_status)}
                      </Tag>
                    ));
                  },
                },
              ]}
            />
          ),
          extra: (
            <a
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/mfg/work-orders/${wo.work_order_id}`);
              }}
            >
              WO detail
            </a>
          ),
        }))}
      />
    </Card>
  );
};

export default FabricationUnitControlBoard;
